<template>
  <b-modal
    centered
    size="lg"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ $t("globals.request_service_call") }}:</h4>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col sm="2">
          <label class="m-2">{{ $t("globals.license_plate") }}:</label>
        </b-col>
        <b-col>
          <b-form-input
            class="m-2"
            size="sm"
            v-model="license_plate"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2">
          <label class="m-2">IMEI:</label>
        </b-col>
        <b-col>
          <ulu-multiselect
            class="m-2"
            v-model="selected_device"
            :options="devices"
            label="imei"
            track-by="imei"
            :placeholder="$t('globals.select_device')"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2">
          <label class="m-2"> {{ $t("globals.reason") }}: </label>
        </b-col>
        <b-col>
          <b-form-select
            v-model="reason.selected"
            :options="reason.options"
            class="m-2"
          >
          </b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="reason.selected == 'other'">
        <b-col sm="2">
          <label class="m-2"> {{ $t("globals.other") }}: </label>
        </b-col>
        <b-col>
          <b-form-textarea
            v-model="reason.other_fill"
            :state="reason.other_fill.length >= 1"
            rows="3"
            class="m-2"
          >
          </b-form-textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2">
          <label class="m-2"> {{ $t("globals.contact_information") }}: </label>
        </b-col>
        <b-col>
          <b-form-textarea
            v-model="contactAllInfo"
            class="m-2"
            rows="5"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col sm="2">
          <label class="m-2"> {{ $t("globals.notes") }}: </label>
        </b-col>
        <b-col>
          <b-form-textarea
            v-model="notes"
            class="m-2"
            rows="3"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save"
            variant="success"
            :disabled="saveDisabled"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {
    "ulu-multiselect": () => import("vue-multiselect")
  },
  props: {
    show: Boolean,
    close: Function,
    devices: Array,
    contactAllInfo: String
  },
  data() {
    return {
      assembly: {
        selected: "professional",
        options: [
          { text: "Professional", value: "professional" },
          { text: "Self", value: "self" }
        ]
      },
      reason: {
        selected: "other",
        other_fill: "",
        options: [],
        /*[
          { text: "No data in Kibana", value: "no_data_kibana" },
          { text: "Split trips / old batch", value: "split_trips_old_batch" },
          { text: "Old Decos CT", value: "old_decos_ct" },
          { text: "DTC interference vehicle", value: "dtc_interference_vehicle" },
          { text: "GPS module defect", value: "gps_module_defect" },
          { text: "FW stuck in update", value: "fw_stuck_update" },
          { text: "Other (fill in)", value: "other" }
        ]*/
      },
      license_plate: "",
      selected_device: null,
      notes: ""
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapActions("constants", ["fetchActiveEnums"]),
    save() {
      let data = {
        query: `
          mutation ServiceServiceCallCreate(
            $service: ServiceInput,
            $service_devices: [ServiceDeviceInput]
          ) {
            res: ServiceServiceCallCreate (
              service: $service
              service_devices: $service_devices
            )
          }
        `,
        variables: {
          service: {
            order_id: parseInt(this.$route.params.id),
            reason: this.reason.selected,
            reason_other: this.reason.other_fill,
            notes: this.notes,
            contact_info: this.contactAllInfo,
          },
          service_devices: [{
            device_id: parseInt(this.selected_device.id),
            license_plate: this.license_plate,
            service_device_type: "inspection"
          }]
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelModal();
      });
    },
    cancelModal() {
      this.close();
    },
    callFetchEnums() {
      this.fetchActiveEnums({this_ref: this, enums: ["service_call_reason"]})
        .then((res) => {
          if (res) {
            this.reason.options = res.service_call_reason;
          }
        })
    },
  },
  computed: {
    saveDisabled() {
      return (
        (this.reason == "value" && this.reason.other_fill.length < 2) ||
        this.selected_device == null
      );
    }
  },
  mounted() {
    this.callFetchEnums();
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
